export const scaleUnit = (value, unit) => {
	if (!value || !unit || Math.abs(value) >= 0.001) {
		return { factor: 1, unit };
	}

	let factor = 1;
	let scaledUnit = unit;
	let scaledValue = value;

	if (/^kg(\s|$)/.test(scaledUnit)) {
		scaledUnit = scaledUnit.replace(/^kg/, "g");
		factor *= 1000;
		scaledValue *= 1000;
	}

	for (const prefix of ["m", "μ", "n"]) {
		if (Math.abs(scaledValue) < 0.001) {
			scaledUnit = prefix + scaledUnit;
			factor *= 1000;
			scaledValue *= 1000;
		}
	}

	return { factor, unit: scaledUnit };
};